const get_discount_key = (data) => {
    return data.is_current ? (data.use_contracted ? 'discount' : 'ACTUAL_DISCOUNT') : 'discount';
}

const get_rebate_key = (data) => {
    return data.is_current ? (data.use_contracted ? 'rebate' : 'effective_rebate') : 'rebate';
}


export {get_discount_key,get_rebate_key}
